<div class="container privacy-policies">
	<dsy-accordion class="content-accordion">
		@for (item of accordionItems(); track item.title) {
		<dsy-accordion-panel slot="panels" class="content-accordion__panel" has-card-style="true">
			<div slot="header" class="content-accordion__header">
				<dsy-icon name="{{ item.icon }}" library="material" size="1.6rem"></dsy-icon>
				<span class="content-accordion__title">{{ item.title }}</span>
			</div>
			<div class="content-accordion__body">
				<flex-privacy-policy-privacy-content [html]="item.content"></flex-privacy-policy-privacy-content>
			</div>
		</dsy-accordion-panel>
		}
	</dsy-accordion>
</div>